module.exports = __webpack_public_path__ + "img/k-grey-woman-front.ee5f018d.jpg";